import React, { useState } from 'react';
import navbarBorder from '../../assets/images/home_screen/navbar-border.png';
import { motion, AnimatePresence } from 'framer-motion';

const SubLinkDropdown = ({ item, navigate, location, isActive }) => {
  const hasSubLinks = item.subLinks && item.subLinks.length > 0;
  const [isOpen, setIsOpen] = useState(false);

  return (
    <div
      className="relative group"
      onMouseEnter={() => setIsOpen(true)}
      onMouseLeave={() => setIsOpen(false)}
    >
      <div
        onClick={() => navigate(item.id)}
        className={`flex justify-center items-center py-1 2xl:py-1.5 md:px-4 lg:px-8 ${
          isActive(item.id) ? 'bg-primary/90' : ''
        } hover:bg-primary transition-all ease-in duration-200 cursor-pointer`}
      >
        <img
          src={navbarBorder}
          alt="navbar-border"
          className="absolute -left-[2px] 2xl:-left-1 top-0 h-full"
        />
        <p className="text-white cursor-pointer [text-shadow:_-1.5px_1.5px_0px_#76569E] text-[14px] lg:text-[16px] 2xl:text-[22px] 3xl:text-[28px] tracking-wider font-[Anton]">
          {item.name}
        </p>
      </div>

      {hasSubLinks && (
        <AnimatePresence>
          {isOpen && (
            <motion.ul
              initial={{ opacity: 0, height: 0 }}
              animate={{ opacity: 1, height: 'auto' }}
              exit={{ opacity: 0, height: 0 }}
              transition={{ duration: 0.3 }}
              className="absolute top-full mt-[1px] bg-[#5F4992]/90 overflow-hidden rounded-b-md min-w-[200px] 2xl:min-w-[270px] 3xl:w-[340px] z-50"
            >
              {item.subLinks.map((sub, subIndex) => (
                <motion.li
                  key={subIndex}
                  initial={{ x: 50, opacity: 0, rotate: -3 }}
                  animate={{ x: 0, opacity: 1, rotate: 0 }}
                  exit={{ x: 50, opacity: 0 }}
                  transition={{
                    type: 'spring',
                    stiffness: 300,
                    damping: 18,
                    delay: 0.09 * subIndex,
                  }}
                  onClick={(e) => {
                    e.stopPropagation();
                    navigate(sub.path);
                  }}
                  className="text-white uppercase px-4 py-2 hover:bg-gradient-to-r from-[#C572A7] to-[#7F76AF] text-sm lg:text-base 2xl:text-[24px] 3xl:text-[24px] 2xl:leading-relaxed font-medium cursor-pointer"
                >
                  {sub.label}
                </motion.li>
              ))}
            </motion.ul>
          )}
        </AnimatePresence>
      )}
    </div>
  );
};

export default SubLinkDropdown;
